import { FormKitTypeDefinition } from '@formkit/core'
import {
  outer,
  wrapper,
  help,
  messages,
  message,
  icon,
  prefix,
  suffix,
  buttonInput,
  buttonLabel,
  localize,
  ignores,
} from '../compose'

/**
 * Input definition for a button.
 * @public
 */
export const button: FormKitTypeDefinition = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* #__PURE__ */ outer(
    /* #__PURE__ */ messages(/* #__PURE__ */ message('$message.value')),
    /* #__PURE__ */ wrapper(
      /* #__PURE__ */ buttonInput(
        /* #__PURE__ */ icon('prefix'),
        /* #__PURE__ */ prefix(),
        /* #__PURE__ */ buttonLabel('$label || $ui.submit.value'),
        /* #__PURE__ */ suffix(),
        /* #__PURE__ */ icon('suffix')
      )
    ),
    /* #__PURE__ */ help('$help')
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: 'input',
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: 'button',
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [localize('submit'), ignores],
  /**
   * A key to use for memoizing the schema. This is used to prevent the schema
   * from needing to be stringified when performing a memo lookup.
   */
  schemaMemoKey: 'h6st4epl3j8',
}
